import './index.scss';
import React, { useState } from 'react';
import { Drawer } from 'antd-mobile';
import { MyContext } from '@/utils/contextManager';

const DrawerWrapper = (props) => {

    const [fComp, setFComp] = useState(null);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const provider = {
        setDrawer() {
          setDrawerVisible(!drawerVisible)
        },
        setFilters(obj) {
          setFComp(obj)
        },
      }

    return (
        <MyContext.Provider value={provider}>
            <Drawer
                className="my-drawer"
                position={'right'}
                sidebarStyle={{position: 'fixed'}}
                sidebar={fComp || <div></div>}
                open={drawerVisible || false}
                touch={false}
            >
                {props.children}
            </Drawer>
        </MyContext.Provider>
    )
}

export default DrawerWrapper